export default function LandingTitle({ title, titleClass, justifyContent }) {
    return (
        <div className={`pt-10 flex justify-${justifyContent}`}>
            <h2 data-aos="fade-in" data-aos-duration="1000" className={`uppercase lg:w-2/3 w-full p-10 pr-10 text-2xl md:text-4xl font-bold ${titleClass} text-left`}>{title}</h2>
        </div>
    )
}